import * as Sentry from '@sentry/react'

export const breadcrumb = (category: string, message: string, data: Record<string, unknown> = {}) => {
    Sentry.addBreadcrumb({
        category,
        message,
        data,
    })
}
